<template>
	<div
		v-if="$parent.$scopedSlots.description || hasDescriptionContent"
		class="carousel-description"
	>
		<slot
			v-if="$parent.$scopedSlots.description"
			name="description"
		/>

		<div v-else>
			<div
				v-if="item.supertitle"
				class="carousel-description__supertitle"
				:aria-label="ariaLabelSupertitle"
			>
				{{ item.supertitle }}
			</div>

			<div
				v-if="item.title"
				class="carousel-description__title"
			>
				<helio-link
					:link="item.link"
					:aria-label="ariaLabelTitle"
				>
					{{ item.title }}
				</helio-link>
			</div>

			<p
				v-if="item.excerpt"
				class="carousel-description__excerpt"
			>
				{{ excerpt }}
			</p>

			<helio-button
				v-if="item.button"
				:color="item.button.color || 'primary'"
				:icon="item.button.icon || null"
				:text="item.button.text || null"
				:link="item.button.link || null"
			/>

			<helio-link
				v-if="item.textLink"
				:class="[
					'carousel-description__text-link',
					`carousel-description__text-link--color-${item.textLink.color || color}`,
				]"
				:link="item.textLink.link ? item.textLink.link : item.link"
			>
				<span v-if="item.textLink.text">
					{{ item.textLink.text }}
				</span>

				<helio-icon
					v-if="item.textLink.icon"
					:token="item.textLink.icon"
					:color="item.textLink.color || color"
				/>
			</helio-link>
		</div>
	</div>
</template>

<script>
import Icon from '../../icon/Icon.vue';
import Link from '../../link/Link.vue';

export default {
	name: 'Description',

	components: {
		'helio-icon': Icon,
		'helio-link': Link,
	},

	props: {
		color: {
			type: String,
			required: true,
			description: 'Sets the color for the inline text link',
		},

		item: {
			type: Object,
			required: true,
			description: 'Sets the current description details for the current card',
		},

		maxExcerptLength: {
			type: Number,
			required: false,
			default: 0,
			description: 'If provided, cuts excerpt avec maxExcerptLength characters and add "..."',
		},
	},

	computed: {
		excerpt() {
			if (this.maxExcerptLength) {
				return `${this.item.excerpt.slice(0, this.maxExcerptLength)}...`;
			}

			return this.item.excerpt;
		},

		ariaLabelTitle() {
			return `${this.$t('aria-label.li-title')}: ${this.item.title}`;
		},

		ariaLabelSupertitle() {
			return `${this.$t('aria-label.li-info')}: ${this.item.supertitle}`;
		},

		hasDescriptionContent() {
			return this.item.supertitle
				|| this.item.title
				|| this.item.excerpt
				|| this.item.textLink
				|| this.item.button;
		},
	},
};
</script>

<style lang="scss" src="./description.scss" />
